const normalizeContextValue = (value, fallback = "") => {
  const normalized = String(value ?? "").trim();
  return normalized || fallback;
};

export const buildSherlocRequestOwnershipKey = (advertiserId, context = {}) =>
  [
    normalizeContextValue(advertiserId),
    normalizeContextValue(context.campaignId, "auto"),
    normalizeContextValue(context.date_start),
    normalizeContextValue(context.date_end),
    normalizeContextValue(context.date_preset),
  ].join(":");

export const isSherlocReportRequestCurrent = (requestContext, activeContext) =>
  Boolean(
    requestContext &&
      activeContext &&
      buildSherlocRequestOwnershipKey(requestContext.advertiserId, requestContext) ===
        buildSherlocRequestOwnershipKey(activeContext.advertiserId, activeContext)
  );
